import { useCallback, useEffect, useRef, useState } from "react";
import { deleteMemberBan, getMemberBanList } from "../../services/membersAdminService";
import { MemberBanModel } from "./models/MemberBanModel";

export const useMemberBans = (userId?: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<MemberBanModel[]>([]);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        if(loading || !userId)
            return;
        try {
            setLoading(true);
            const _data = await getMemberBanList(userId);
            if(!isMountedRef.current)
                return;
            if(!!_data && !!_data.results)
                setList(_data.results);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [userId]);
    
    const removeBan = async () => {
        if(loading || !userId)
            return;
        try {
            setLoading(true);
            await deleteMemberBan(userId);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }

    useEffect(() => {
        load();
    }, [load]);

    return { loading, list, removeBan }
}